import { Step } from "react-joyride";

export const tourStepsMultipleChoice = (): Step[] => {
  const steps: Step[] = [
    {
      target: "h1.mb-8",
      content:
        "Multiple Choice lets you write questions, then answer by clicking a colored button.",
      disableBeacon: true,
    },
    {
      target: ".game-instructions",
      content:
        "Type a question and two to four answers. Mark the correct answer with the radio button. Use Edit on a saved question to fix the prompt or correct answer. Leave extra boxes blank if you only need two or three choices.",
    },
    {
      target: "#questionPrompt",
      content:
        "Add as many questions as you want. They stay on this device so you can play again later. If an answer is a color name like Blue or Orange, that button uses that color.",
    },
    {
      target: ".start-button",
      content:
        "Start when you have at least one question. Answer positions still shuffle each time. Color-named answers keep matching button colors.",
    },
  ];

  return steps;
};
